// angular
// 	.module("HeroPRO")
// 	.controller("POSignModalController", POSignModalController);

import './pomodal.scss';

/* @ngInject */
export default function POSignModalController(POSignFactory, $stateParams, $state, $analytics, Timestamp, FRInformationFactory, ModalService, data) {
    const vm = this;
    vm.appInfo = data.AppInfo;
    vm.POs = data.POs;

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */
    function sendEmail(po, emailOnly) {
        POSignFactory.emailPO($stateParams.appId, po).then(() => {
            if (emailOnly) {
                po.emailSending = false;
                po.emailSent = true;
                po.Owner.EDocumentRecipientStatusDate = new Date();
            }
        });
    }

    /* -----  End of Private Functions  ------*/


    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.emailPO = function (po) {
        po.ctaClicked = true;
        const eventName = (po.sent === true) ? 'Resend Email Click' : 'Send Email Click';
        $analytics.eventTrack(eventName, { category: 'Modal: GetSigs', label: 'Start Work' });

        if (vm.validateEmail(po)) {
            po.emailSending = true;
            sendEmail(po, true);
        } else {
            po.hasValidEmail = false;
        }
    };

    vm.closePOSignModal = function () {
        $analytics.eventTrack('Get Signatures Modal Close', { category: 'Modal: GetSigs', label: 'Start Work' });
        ModalService.closeLgModal();
        $state.go($state.$current, null, { reload: true });
    };

    vm.trackSignNowClick = function (po) {
        po.ctaClicked = true;
        if (po.hasValidEmail) {
            sendEmail(po, false);
        }
    };

    vm.validateEmail = function (po) {
	    po.hasValidEmail = false;
	    if (po.Owner.Email && po.Owner.Email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
	        po.hasValidEmail = true;
	    }
	    return po.hasValidEmail;
    };
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/startWork/PO-Sign/POSignModalController.js